import { render, staticRenderFns } from "./mixtureSettings.vue?vue&type=template&id=2d974947"
import script from "./mixtureSettings.vue?vue&type=script&lang=js"
export * from "./mixtureSettings.vue?vue&type=script&lang=js"
import style0 from "./mixtureSettings.vue?vue&type=style&index=0&id=2d974947&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports